import { base_url, updateImageUrlsMEI } from 'api/constants';
import { UploadFile } from 'api/endpoints';
import React, { useEffect, useMemo, useRef, useState } from 'react';

import { toast } from 'react-toastify';

import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import QuillBetterTable from 'quill-better-table';



const MEICKEditor = ({ value, onchangeValue }) => {

    const quillRef = useRef(null);

    // useEffect(() => {
    //     console.log(value)
    // }, [value])


    useEffect(() => {
        if (quillRef.current) {
            const editor = quillRef.current.getEditor();
            const editorContainer = editor.root;
            editorContainer.style.minHeight = '250px';
        }
    }, []);

    const handleImageUploadQui = async (file) => {
        const ckFdata = new FormData();
        ckFdata.append('file', file);

        try {
            const res = await UploadFile(ckFdata);
            const index = res?.data?.indexOf("\\MediaGallery");
            const extractedPath = res?.data?.substring(index);
            const encodedPath = extractedPath.replaceAll(' ', '%20');
            console.log(encodedPath, 'encodedPath');
            const relativePath = encodedPath.replaceAll('\\', '/');
            return `${base_url}${relativePath}`;
        } catch (err) {
            toast.error('Failed Uploading Media', {
                theme: "colored",
            });
            return null;
        }
    };


    const imageHandler = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();

        input.onchange = async () => {
            const file = input.files[0];
            if (file) {
                const url = await handleImageUploadQui(file);
                console.log(url, 'url')
                if (url) {
                    const range = quillRef.current.getEditor().getSelection();
                    quillRef.current.getEditor().insertEmbed(range.index, 'image', url);
                }
            }
        };
    };

    const qqmodules = useMemo(() => ({
        imageResize: {
            parchment: Quill.import('parchment'),
            modules: ['Resize', 'DisplaySize']
        },

        imageActions: {},
        imageFormats: {},
        toolbar: {
            container: [
                [{ 'header': [] }, { 'font': [] }],
                [{ size: [] }],

                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{ 'align': [] }],
                [{ 'list': 'ordered' }, { 'list': 'bullet' },
                { 'indent': '-1' }, { 'indent': '+1' }],
                ['link', 'image', 'video'],
                ['formula',],
                ['clean'],
            ],
            handlers: {
                image: imageHandler
            },

        },
        clipboard: {
            matchVisual: false,
        },
    }), []);
    const qformats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image', 'video', 'align', 'float', 'width', 'style', 'table',
    ]

    return (
        <>

            <ReactQuill
                ref={quillRef}
                theme='snow'
                value={value}
                onChange={onchangeValue}
                modules={qqmodules}
                formats={qformats}
                bounds={'.app'}
                style={{ minHeight: '250px', marginBottom: '10px' }}
            />


        </>
    );
};

export default MEICKEditor;
